export const isValidEmail = (email) => email.toLowerCase().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
